const debug = false

const datos = {
    urlapi: debug === true ? 'http://localhost:4000' : 'https://tremus-cafeteria.delpasystem.com',
    key_local_storage_user: "bumer_bknd_user"
}

module.exports = datos